// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"257":"fastbooking","301":"splide","723":"lightbox"}[chunkId] || chunkId) + ".js";
};